import { createSlice } from "@reduxjs/toolkit";
import { E_PedanaStepAltezza, E_PedanaRivestimento} from "../../components/Utils/enumerations";

export const uiPedanaSlice = createSlice({
    name: "UI_pedana",
    initialState: {
        isVisible: false,    
        stepAltezza: E_PedanaStepAltezza.Da0a50.toString(),
        realAltezza: 0,
        rivestimento: E_PedanaRivestimento.WPC.toString(),
        minigonna: true,
        rampaDisabili: false,
        predisposizioneParaventi: false,
        numeroBotole: 0,
        hasAttacchiEsterni: false,
    },
    reducers: {
        setPedanaMenuVisible: (state, action) => {            
            state.isVisible = action.payload;         
        },  
        handlePedanaStepAltezza: (state, action) => {
            state.stepAltezza = action.payload;
            switch(action.payload) {
                case(E_PedanaStepAltezza.Da0a50.toString()):
                state.realAltezza = 0.0050
                break;
                case(E_PedanaStepAltezza.Da50a95.toString()):
                state.realAltezza = 0.095;
                break;
                case(E_PedanaStepAltezza.Da95a125.toString()):
                state.realAltezza = 0.125;
                break;
                case(E_PedanaStepAltezza.Da125a250.toString()):
                    state.realAltezza = 0.250;
                break;
                default:
                    state.realAltezza = 0;
                break;
            }      
        },  
        handlePedanaRivestimento: (state,action) => {
            state.rivestimento = action.payload;
        },
        handlePedanaMinigonna: state => {
            state.minigonna = !state.minigonna;
        },
        handlePedanaRampaDisabili: state => {
            state.rampaDisabili = !state.rampaDisabili;
        },
        handlePedanaPredParaventi: state => {
            state.predisposizioneParaventi = !state.predisposizioneParaventi;
        },
        handlePedanaBotole: (state, action) => {
            state.numeroBotole = action.payload;          
        },
        handleHasAttacchiEsterni: (state, action) => {
            state.hasAttacchiEsterni = action.payload;
        }
    }
});

export const { setPedanaMenuVisible,   
               handlePedanaStepAltezza,        
               handlePedanaRivestimento,
               handlePedanaMinigonna,
               handlePedanaRampaDisabili,
               handlePedanaPredParaventi,
               handlePedanaBotole,
               handleHasAttacchiEsterni            
            } = uiPedanaSlice.actions;

export default uiPedanaSlice.reducer;